Banner = {
	init: function () {
		if(typeof Editor != "undefined") return;
		var img = $('.row.banner img').attr('src');
		$('.row.banner .image').css({'background-image': 'url(' + img + ')'});
	}
}